import { render, staticRenderFns } from "./DraftEmailPanel.vue?vue&type=template&id=0e241916&scoped=true"
import script from "./DraftEmailPanel.vue?vue&type=script&lang=js"
export * from "./DraftEmailPanel.vue?vue&type=script&lang=js"
import style0 from "./DraftEmailPanel.vue?vue&type=style&index=0&id=0e241916&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e241916",
  null
  
)

export default component.exports